function text (value) {
  return value === undefined || value === null ? '' : String(value)
}

export function savedDraftIdentity2 (source) {
  const raw = source && source.active_saved_draft
  if (!raw || typeof raw !== 'object') return null
  const savedId = raw.saved_id
  const version = text(raw.saved_updated_at)
  if ((savedId === '' || savedId === undefined || savedId === null) || !version) return null
  if (source && text(source.saved_id) !== text(savedId)) return null
  if (source && text(source.saved_updated_at) !== version) return null
  return {
    saved_id: savedId,
    saved_updated_at: version,
    builder_identity: text(raw.builder_identity)
  }
}

export function activateSavedDraft2 (target, source) {
  if (!target || !source) return null
  const savedId = source.saved_id
  const version = text(source.saved_updated_at)
  if ((savedId === '' || savedId === undefined || savedId === null) || !version) return clearSavedDraft2(target)
  const identity = {
    saved_id: savedId,
    saved_updated_at: version,
    builder_identity: text(source.builder_identity || target.timing_workspace_id)
  }
  target.active_saved_draft = identity
  target.saved_id = identity.saved_id
  target.saved_updated_at = identity.saved_updated_at
  return identity
}

export function clearSavedDraft2 (target) {
  if (!target) return null
  target.active_saved_draft = null
  target.saved_id = ''
  target.saved_updated_at = ''
  target.saved_name = ''
  return null
}

export function savedDraftSubmissionFields2 (source) {
  const identity = savedDraftIdentity2(source)
  return identity ? { saved_id: identity.saved_id, saved_updated_at: identity.saved_updated_at } : {}
}
